class Element {
  constructor() {
    this.listeners = {};
  }

  mount(el) {
    if (typeof el === 'string') {
      el = document.querySelector(el)[0];
    }

    el.innerHTML = `
      <div id='stripe-elements'>
        <input id="stripe-cardnumber" placeholder="cardnumber" size="16" type="text" id='cardnumber'>
        <input placeholder="exp-date" size="6" type="text" id='exp-date'>
        <input placeholder="cvc" size="3" type="text" id='cvc'>
      </div>
    `;

    const changed = () => {
      (this.listeners['change'] || []).forEach((handler) =>
        handler({ complete: true })
      );
    };

    document.querySelectorAll('#stripe-elements input').forEach((input) => {
      input.addEventListener('change', changed, false);
    });
  }

  on(event, handler) {
    this.listeners[event] = this.listeners[event] || [];
    this.listeners[event].push(handler);
  }

  update() {}

  destroy() {}
}

const fakeStripe = () => ({
  elements: () => ({
    create: () => new Element(),
  }),

  handleCardSetup: () =>
    new Promise((resolve) => {
      resolve({});
    }),

  handleCardPayment: () =>
    new Promise((resolve) => {
      resolve(window.StripeTestData.handleCardPaymentResponse);
    }),

  paymentRequest: (config) => {
    window.stripePaymentRequestLabelForSystemSpecs = config.total.label;

    return {
      canMakePayment: () =>
        new Promise((resolve) => {
          resolve({ applePay: window.enableApplePay });
        }),
      on: (event, handler) => {
        document
          .querySelector('.express-donate-button')
          .addEventListener(event, handler);
      },
      show: () => {
        const event = new CustomEvent('paymentmethod');

        event.complete = () => null;
        event.paymentMethod = { id: 'pi_stubbed_payment_method' };
        event.payerName = window.StripeTestData.payerName;
        event.payerEmail = window.StripeTestData.payerEmail;

        setTimeout(
          () =>
            document
              .querySelector('.express-donate-button')
              .dispatchEvent(event),
          1000
        );
      },
    };
  },
});

export default fakeStripe;
